<app-box-picker (selectedBox)="newAppSelected($event)" [config]="config" header="Select an App"></app-box-picker>